import type { FaireProductEntity } from "../../entity_types/product";

export const p_tv6p6x5cbn: FaireProductEntity = {
  token: "p_tv6p6x5cbn",
  type: "product",
  name: "Little Notes® Envelopes - Petal - Set of 20",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f51bb69be908098eba35adc20208a6af1c266a840a954775e676a8a85b4093de.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description:
    "Round out your Little Notes® collection with our Little Notes® Envelopes: a set of 20 tiny envelopes, each just the right size for a single Little Note. Perfect for a tip, a secret note, or to add a gummy bear to sweeten the love. These petite envelopes turn every Little Note into a secret surprise.\n\nPlease note: These envelopes are so adorably tiny that they're too small for the postal service, so hand-deliver only!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:20.883Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
